import { forwardRef } from 'react';
import { styled } from '@mui/material/styles';
import MuiPopper from '@mui/material/Popper';
import MenuList from '@mui/material/MenuList';

const StyledPopper = styled(MuiPopper)({
    boxShadow:
        'rgb(0 0 0 / 20%) 0px 5px 5px -3px, rgb(0 0 0 / 14%) 0px 8px 10px 1px, rgb(0 0 0 / 12%) 0px 3px 14px 2px',
    zIndex: 1300,
    background: '#fff',
    padding: '8px 0',
    borderRadius: 8,
    '.MuiMenuItem-root': {
        padding: '8px 16px',
        fontSize: '14px',
        lineHeight: '16px',
        width: '100%',
        justifyContent: 'flex-start',
    },
});

const Popper = forwardRef(({ children, popperOptions, ...props }, ref) => {
    return (
        <StyledPopper
            ref={ref}
            disablePortal={true}
            popperOptions={{
                placement: 'bottom',
                modifiers: [
                    {
                        name: 'preventOverflow',
                        options: {
                            boundary: 'viewport',
                            altAxis: true,
                            padding: 8,
                        },
                    },
                    {
                        name: 'flip',
                        options: {
                            fallbackPlacements: ['left', 'bottom', 'top', 'right'],
                        },
                    },
                ],
                ...popperOptions,
            }}
            {...props}
        >
            {children}
        </StyledPopper>
    );
});

Popper.displayName = 'Popper';

export const PopperMenu = forwardRef(({ children, ...props }, ref) => (
    <Popper ref={ref} {...props}>
        <MenuList disablePadding>{children}</MenuList>
    </Popper>
));

PopperMenu.displayName = 'PopperMenu';

export default Popper;
